<template>
  <div>
    <el-row>
      <el-col :span="24">
      <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>当前美钥码的目标页面跟踪信息（码ID: {{qrid}})</span>
        <el-button style="margin-left: 300px;padding: 3px 0" type="text" @click="openWechatTrackPages()">查看所有美钥码的目标页面追踪情况</el-button>
      </div>
      <el-table
      :data="log_infos"
      style="width: 100%">
      <el-table-column
        label="头像"
        width="120"
      >
      <template slot-scope="scope">
        <img :src="scope.row.wechat_data.headimgurl" class="avatar">
      </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop="wechat_data.nickname"
        label="用户姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="wechat_data.sex"
        label="性别"
        width="120">
      </el-table-column>
      <el-table-column
        prop="wechat_data.province"
        label="省份"
        width="180">
      </el-table-column>
      <el-table-column
        prop="wechat_data.country"
        label="国家"
        width="180">
      </el-table-column>
    </el-table>
        </el-card>
        </el-col>
    </el-row>
    </div>
</template>
<script type="text/javascript">
import {get_wechat_track_logs_by_track_code} from '@/api/qr_utils.js'
export default {
  name: 'wechatTrackByCode',
  data () {
    return {
      qrid: this.$route.params.qrid,
      track_code: this.$route.params.track_code,
      log_infos: null
    }
  },
  mounted () {
    get_wechat_track_logs_by_track_code(this.track_code).then(response => {
      let response_data = response.data.data
      for (let rdi in response_data) {
        if (response_data[rdi].wechatTrackUserInfo) {
          response_data[rdi].wechat_data = JSON.parse(response_data[rdi].wechatTrackUserInfo)
        }
      }
      this.log_infos = response_data
    })
  },
  methods: {
    openWechatTrackPages () {
      window.open("/wechat_page_track/page/1/num/10"); 
    }
  }
}
</script>
<style type="text/css" scoped>
.box-card {
  margin: 10px 15px;
}
.avatar {
  width: 35px;
  height: 35px;
  border-radius: 35px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>
